import React from "react"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import { useSelector } from "react-redux"
import { SUPERADMIN_NAV_LINKS } from "./superadminNav"
import isPermissionEnabled from "common/isPermissionEnabled"

const canAccessNavItem = (permission, userRole, accountType, accountScope) => {
  if (!permission) {
    return true
  }
  return isPermissionEnabled(
    userRole,
    permission.categoryId,
    permission.permissionId,
    accountType,
    accountScope
  )
}

/**
 * Vertical sidebar menu for platform (super-admin) operators only.
 * Tenant admins use {@link SidebarContent} instead.
 */
const handleMenuToggleClick = event => {
  event.preventDefault()
}

const SuperAdminSidebarContent = ({ t }) => {
  const { userRole, accountType, accountScope } = useSelector(
    state => state.Login || {}
  )

  return (
    <>
      {SUPERADMIN_NAV_LINKS.map(item => {
        const visibleChildren = (item.children || []).filter(child =>
          canAccessNavItem(child.permission, userRole, accountType, accountScope)
        )

        if (visibleChildren.length > 0) {
          const parentAllowed =
            canAccessNavItem(item.permission, userRole, accountType, accountScope) ||
            visibleChildren.length > 0

          if (!parentAllowed) {
            return null
          }

          return (
            <li key={item.path}>
              <Link
                to="#"
                className="has-arrow"
                onClick={handleMenuToggleClick}
              >
                <i className={item.icon}></i>
                <span>{t(item.titleKey)}</span>
              </Link>
              <ul className="sub-menu mm-collapse" aria-expanded="false">
                {visibleChildren.map(child => (
                  <li key={child.path}>
                    <Link to={child.path}>{t(child.titleKey)}</Link>
                  </li>
                ))}
              </ul>
            </li>
          )
        }

        if (!canAccessNavItem(item.permission, userRole, accountType, accountScope)) {
          return null
        }

        return (
          <li key={item.path}>
            <Link to={item.path}>
              <i className={item.icon}></i>
              <span>{t(item.titleKey)}</span>
            </Link>
          </li>
        )
      })}
    </>
  )
}

SuperAdminSidebarContent.propTypes = {
  t: PropTypes.func.isRequired,
}

export default SuperAdminSidebarContent
